import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class HttpErrorHandler {

    abstract handleError(httpError: HttpErrorResponse): Observable<{ type: 'error' }>

}